import React from 'react';

export const inferRoomIcon = (item) => {
  const name = `${item?.name?.en || ''} ${item?.name?.fr || ''}`.toLowerCase();
  if (name.includes('basement') || name.includes('sous-sol')) return 'basement';
  if (name.includes('powder') || name.includes('salle d’eau')) return 'toilet';
  if (name.includes('bathroom') || name.includes('salle de bain')) return 'bath';
  if (name.includes('bedroom') || name.includes('chambre')) return 'bed';
  if (name.includes('kitchen') || name.includes('cuisine')) return 'kitchen';
  if (name.includes('living') || name.includes('salon')) return 'sofa';
  if (name.includes('dining') || name.includes('salle à manger')) return 'dining';
  if (name.includes('stair') || name.includes('escalier')) return 'stairs';
  if (name.includes('window') || name.includes('fenêtre')) return 'window';
  if (name.includes('oven') || name.includes('four')) return 'oven';
  if (name.includes('refrigerator') || name.includes('réfrigérateur')) return 'fridge';
  if (name.includes('cabinet') || name.includes('armoire')) return 'cabinet';
  if (name.includes('linen') || name.includes('linge')) return 'linen';
  return 'sparkles';
};

const drawings = {
  basement: <><path d="M4 11 12 5l8 6"/><path d="M6 10v9h12v-9M9 19v-4h6v4"/><path d="M3 22h18"/></>,
  toilet: <><path d="M7 5h7v5H7zM14 7h3c1.7 0 3 1.3 3 3v1"/><path d="M6 11h13c0 4-2.2 7-6 7s-7-3-7-7ZM10 18v3h6"/></>,
  bath: <><path d="M3 12h18v2a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5z"/><path d="M6 12V7a3 3 0 0 1 6 0M5 19l-1 2M19 19l1 2"/></>,
  bed: <><path d="M3 18V8M21 18v-6a2 2 0 0 0-2-2H9a3 3 0 0 0-3 3v2"/><path d="M3 15h18M7 10V7h5a2 2 0 0 1 2 2v1"/></>,
  kitchen: <><path d="M5 10h14l-1 9H6zM8 10V7M16 10V7M10 5h4M8 22h8"/><path d="M9 14h6"/></>,
  sofa: <><path d="M5 11V9a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v2"/><path d="M4 10a2 2 0 0 0-2 2v5h20v-5a2 2 0 0 0-2-2M6 17v3M18 17v3M7 13h10"/></>,
  dining: <><path d="M5 4v7M3 4v4a2 2 0 0 0 4 0V4M5 11v9M15 4v16M15 4c4 2 4 7 0 9"/><path d="M10 15h10"/></>,
  stairs: <path d="M3 20h4v-4h4v-4h4V8h4V4h2"/>,
  window: <><rect x="4" y="3" width="16" height="18" rx="1"/><path d="M12 3v18M4 12h16"/></>,
  oven: <><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M5 8h14M8 6h.01M11 6h.01M9 12h6v6H9z"/></>,
  fridge: <><rect x="6" y="2" width="12" height="20" rx="2"/><path d="M6 10h12M9 6v2M9 13v3"/></>,
  cabinet: <><rect x="4" y="3" width="16" height="18" rx="1"/><path d="M12 3v18M9 12h.01M15 12h.01"/></>,
  linen: <><path d="M4 7h16v12H4zM4 11h16M8 7V5h8v2"/><path d="m9 15 2 2 4-4"/></>,
  sparkles: <><path d="m12 3 1.2 3.8L17 8l-3.8 1.2L12 13l-1.2-3.8L7 8l3.8-1.2z"/><path d="m6 14 .8 2.2L9 17l-2.2.8L6 20l-.8-2.2L3 17l2.2-.8z"/></>
};

export const ROOM_ICON_OPTIONS = Object.keys(drawings);

const RoomIcon = ({ item, className = '' }) => (
  <span className={`room-icon ${className}`} aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {drawings[item?.icon] || drawings[inferRoomIcon(item)]}
    </svg>
  </span>
);

export default RoomIcon;
